import { createSlice } from "@reduxjs/toolkit";
import {
  AboutSushilData,
  AboutSushilInitialStatus,
} from "../../../../../types/webCms/homePage/aboutSushil";
import {
  getAllAboutSushilAsync,
  updateAboutSushilAsync,
} from "./aboutSushilApi";

const initialState: AboutSushilInitialStatus<AboutSushilData> = {
  loading: false,
  manageLoading: false,
  aboutSushilDataList: [],
  countAboutSushilData: 0,
};

const aboutSushilSlice = createSlice({
  name: "admin-about-sushil",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllAboutSushilAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllAboutSushilAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.aboutSushilDataList = action.payload.data;
        state.countAboutSushilData = action.payload.length;
      })
      .addCase(getAllAboutSushilAsync.rejected, (state) => {
        state.loading = false;
        state.aboutSushilDataList = [];
        state.countAboutSushilData = 0;
      });

    // update
    builder
      .addCase(updateAboutSushilAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateAboutSushilAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateAboutSushilAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default aboutSushilSlice;
